import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TextField,
    Typography,
    Box,
} from "@mui/material";
import { useState } from "react";

interface SetResult {
    setNumber: number;
    scoreA: number;
    scoreB: number;
}

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: (results: SetResult[]) => void;
}

export default function TrainingResultDialog({ open, onClose, onConfirm }: Props) {
    const [results, setResults] = useState<SetResult[]>(
        Array.from({ length: 5 }, (_, i) => ({
            setNumber: i + 1,
            scoreA: 0,
            scoreB: 0,
        }))
    );

    const handleChange = (index: number, field: keyof SetResult, value: string) => {
        const updated = [...results];
        updated[index][field] = Number(value);
        setResults(updated);
    };

    const handleConfirm = () => {
        const valid = results.filter(r => r.scoreA > 0 || r.scoreB > 0);
        onConfirm(valid);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                <Typography variant="h6" fontWeight="bold">
                    Match Results
                </Typography>
            </DialogTitle>

            <DialogContent dividers>
                <Box sx={{ overflowX: "auto" }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                                    Set
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                                    Team A
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                                    Team B
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {results.map((r, idx) => (
                                <TableRow key={idx}>
                                    <TableCell align="center">{r.setNumber}</TableCell>
                                    <TableCell align="center">
                                        <TextField
                                            type="number"
                                            size="small"
                                            variant="outlined"
                                            value={r.scoreA}
                                            onChange={(e) =>
                                                handleChange(idx, "scoreA", e.target.value)
                                            }
                                            inputProps={{
                                                min: 0,
                                                style: { textAlign: "center", width: 60 },
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        <TextField
                                            type="number"
                                            size="small"
                                            variant="outlined"
                                            value={r.scoreB}
                                            onChange={(e) =>
                                                handleChange(idx, "scoreB", e.target.value)
                                            }
                                            inputProps={{
                                                min: 0,
                                                style: { textAlign: "center", width: 60 },
                                            }}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" onClick={handleConfirm}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}
